import React from 'react'
import ChangePassword from "./ChangePassword"
import DeactivateAccount from './DeactivateAccount';
import SignOutOffAllDevices from './SignOutOffAllDevices';

export default function Account() {
  
      
  return (
    <div>
      <div className='lightBlueBanner mt-2'>
<p className=' fw-bold p-2'>Account</p>
      </div>
          <ChangePassword />
          <div className="d-flex justify-content-center p-0 m-0">
          <hr  className="thick-hr w-75"/>
          </div>
          <SignOutOffAllDevices />
          <div className="d-flex justify-content-center p-0 m-0">
          <hr  className="thick-hr w-75"/>
          </div>
          <DeactivateAccount />

         
    </div>
  )
}
